module.exports = __webpack_public_path__ + "assets/favicons/apple-touch-icon.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=assets/favicons/[name].[ext]!./src/assets/favicons/apple-touch-icon.png
// module id = DWyd
// module chunks = 1